import useMediaQuery from './useMediaQuery'
import MediaQuery from './Component'
import toQuery from './toQuery'
import Context from './Context'

export {
  MediaQuery as default,
  useMediaQuery,
  toQuery,
  Context
}

export type {
  MediaQueryTypes,
  MediaQueryType,
  MediaQueryFeatures,
  MediaQueryMatchers,
  MediaQueryAllQueryable
} from './types'
